module.exports = __webpack_public_path__ + "static/media/30.c69af276.webp";